import { MessageAnchor, MessageVersion } from 'src/models/anchor-and-version/message.model';
import { Component } from '@angular/core';
import { CrudBaseModalComponent } from '../crud-base-modal/crud-base-modal.component';
import { CrudModalAbstractComponent } from '../crud-base-modal/crud-modal-abstract.component';
import { ModalProps } from '../crud-base-modal/modal-field.interface';
import { pgnValidator } from 'src/validators/pgn.validator';

@Component({
    selector: 'app-crud-message-modal',
    template: `<app-crud-base-modal #baseModal [modalProps]="modalProps"></app-crud-base-modal>`,
    imports: [CrudBaseModalComponent],
})
export class CrudMessageModalComponent extends CrudModalAbstractComponent<
    MessageAnchor,
    MessageVersion
> {
    public modalProps: ModalProps = {
        title: 'Message',
        validateNameFormat: true,
        anchorFields: [],
        versionFields: [
            {
                field: 'changeRequestKey',
                label: 'Change Request',
                type: 'lazy-dropdown',
                required: true,
                order: 1,
            },
            { field: 'name', label: 'Name', type: 'text', required: true, order: 2 },
            { field: 'fullName', label: 'Full Name', type: 'text', order: 3 },
            {
                field: 'dataLength',
                label: 'Data Length (bytes)',
                type: 'number',
                order: 4,
                defaultValue: 0,
            },
            {
                field: 'parameterGroupNumber',
                label: 'PGN',
                type: 'mask',
                mask: '0x*****',
                placeholder: '0x_____',
                order: 5,
                validator: pgnValidator,
            },
            {
                field: 'pgPrio',
                label: 'Priority',
                type: 'dropdown',
                order: 6,
                defaultValue: 0,
                options: [
                    { label: '0', value: 0 },
                    { label: '1', value: 1 },
                    { label: '2', value: 2 },
                    { label: '3', value: 3 },
                    { label: '4', value: 4 },
                    { label: '5', value: 5 },
                    { label: '6', value: 6 },
                    { label: '7', value: 7 },
                ],
            },
            {
                field: 'pgRepetition',
                label: 'Repetition Type',
                type: 'dropdown',
                order: 7,
                defaultValue: 0,
                options: [
                    { label: 'Cyclic', value: 0 },
                    { label: 'On Change', value: 1 },
                    { label: 'On Request', value: 2 },
                    { label: 'Spontaneous', value: 3 },
                    { label: 'When Active', value: 4 },
                ],
            },
            {
                field: 'cycleTime',
                label: 'Cycle Time (milliseconds)',
                type: 'number',
                order: 8,
                defaultValue: 0,
            },
            {
                field: 'tmin',
                label: 'Tmin (milliseconds)',
                type: 'number',
                order: 9,
                defaultValue: 0,
            },
            {
                field: 'tmax',
                label: 'Tmax (milliseconds)',
                type: 'number',
                order: 10,
                defaultValue: 0,
            },
            {
                field: 'pgDiagnosticType',
                label: 'Diagnostic Type',
                type: 'dropdown',
                order: 11,
                defaultValue: 0,
                options: [
                    { label: 'No', value: 0 },
                    { label: 'Physical', value: 1 },
                    { label: 'Functional', value: 2 },
                ],
            },
            { field: 'messageNote', label: 'Message Note', type: 'textarea', order: 12 },
            { field: 'comment', label: 'Comment', type: 'textarea', order: 13 },
            { field: 'isActive', label: 'Is Active', type: 'switch', order: 14 },
        ],
    };
}
